<div style="width:100%">
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white; position: relative;">
      <icon-chart [headerConfig]="item?.config?.widget_header_configuration" [iconList]="iconList" [data]="data"
        [pageKey]="pageKey" [chartName]="divId" [config]="ChordChartContainer" [fullscreen]="isFullscreen" [expand]="fs"
        [item]="item" [chordChartRef]="this"
        [settings]="{ showLabels}">
      </icon-chart>

      <!-- Loading Spinner -->
      <div style="min-height: 400px; display: flex; justify-content: center; align-items: center;" *ngIf="isLoading">
        <loading style="width: 100%; height: 100%;"> </loading>
      </div>

      <div class="chart-controls" *ngIf="!noData && !isLoading">
        <div class="button-group">
          <div *ngIf="hasSelections" class="selection-display">{{ getSelectionText() }}</div>
          <button *ngIf="hasSelections" class="control-button" (click)="clearSelections()">
            Clear Selections
          </button>
        </div>

        <div class="button-group">
          <button *ngIf="isOverflowing" class="control-button" (click)="toggleShowMore()">
            {{ showMore ? 'Show Less' : 'Show More' }}
          </button>
          <button class="control-button" (click)="filterData()">
            Filter
          </button>
          <button class="control-button" (click)="resetChart()">
            Reset
          </button>
          <button class="nav-arrow-button" (click)="goToPixelMap($event)" title="Go to Pixel Map">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Chart container - hidden when noData or loading -->
      <div id="chord_chart" #ChordChartContainer [class.expanded]="showMore" [class.fullscreen-mode]="isFullscreen"
           [style.display]="(noData || isLoading) ? 'none' : ''"></div>

      <!-- No Data / Error Message -->
      <div style="height: 500px; width: auto;" *ngIf="noData && !isLoading">
        <span class="bg-text">{{ error_name ? error_name : 'There is no data for this time period' }}</span>
      </div>

      <div class="chord-tooltip"></div>
      
      <!-- Interactive Tooltip Overlay -->
      <div class="interaction-tooltip" *ngIf="interactionTooltipData?.visible" 
           [style.left.px]="interactionTooltipData.x" 
           [style.top.px]="interactionTooltipData.y">
          <div class="header" (mousedown)="startDragActual($event)">
              <div class="header-left">
                  <span class="header-text">{{ interactionTooltipData.source }} Connections</span>
                  <button class="clear-btn" (click)="toggleAllInteractionTargets(); $event.stopPropagation()">Select All</button>
              </div>
              <button class="close-btn" (click)="closeInteractionTooltip(); $event.stopPropagation()">×</button>
          </div>
          <div class="list-container">
              <div *ngFor="let target of interactionTooltipData.targets" class="list-item">
                  <label>
                      <input type="checkbox" [checked]="target.selected" (change)="toggleInteractionTarget(target)">
                      {{ target.name }}
                  </label>
              </div>
          </div>
          <div class="footer">
              <button class="select-btn" 
                      [disabled]="!canSelectInteraction"
                      (click)="confirmInteractionSelection()">
                  Select
              </button>
          </div>
      </div>
<div class="flourish-embed flourish-chart" data-src="visualisation/27174819" data-height="500px"><script src="https://public.flourish.studio/resources/embed.js"></script><noscript><img src="https://public.flourish.studio/visualisation/27174819/thumbnail" width="100%" height="500px" alt="chart visualization" /></noscript></div>    </article>
  </main>
</div>